import { ListingLos } from '@/utils/platform-api/__generated__/graphql';

import { getCheckoutDate } from './date';

function calculateSubtotalRateAndDates(listingLos: ListingLos) {
  const ratesAndDates: {
    rent: number;
    subtotal: number;
    discount: number;
    listing: string;
    check_in: string;
    check_out: string;
  }[] = [];
  listingLos.los.forEach((los) => {
    los.rates.forEach((rate) => {
      const subtotal = (rate.fee_details?.total || 0) + rate.amount;
      ratesAndDates.push({
        rent: rate.amount,
        subtotal: subtotal,
        discount: rate.discount || 0,
        listing: listingLos.id,
        check_in: los.cal_date,
        check_out: getCheckoutDate(los.cal_date, rate.nights),
      });
    });
  });
  return ratesAndDates;
}
export default calculateSubtotalRateAndDates;
